import * as React from "react";
import { observer } from "mobx-react";
import { MDBCol, MDBRow } from "mdbreact";
import { FormGroup, HTMLSelect, InputGroup, Tab, Tabs } from "@blueprintjs/core";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";

import CfopSaida from "./cfop_saida";
import CfopEntrada from "./cfop_entrada";
import ImportCfops from "./import_cfops";
import { observable } from "mobx";
import { newEmpresa } from "../../model";
import CstsIPI from "./ipi";
import CstsPIS from "./pis";
import CstsCofins from "./cofins";

@observer
export default class ConfiguracaoImportacaoNfe extends React.Component<{}, {}> {

    obs = observable({
        open_select_import_saida: false as boolean,
        open_select_import_entrada: false as boolean
    })

    constructor(props: any) {
        super(props);
    }

    async hanldeChangeTabConfig(tab: string) {
        SpedEfdStore.obs.select_config_entradas_tab = "opcoes"
        SpedEfdStore.obs.select_config_saidas_tab = "opcoes"
        SpedEfdStore.obs.cfops_current = 1

        if (tab == "saida") {
            await SpedEfdStore.loadSped(SpedEfdStore.obs.selectedEmpresa.cnpj, tab, "nfe")
            SpedEfdStore.obs.tab_entrada_saida = tab;
            SpedEfdStore.obs.entrada_saida = "saida"
        }

        else if (tab == "entrada") {
            await SpedEfdStore.loadSped(SpedEfdStore.obs.selectedEmpresa.cnpj, tab, "nfe")
            SpedEfdStore.obs.tab_entrada_saida = tab;
            SpedEfdStore.obs.entrada_saida = "entrada"
        } else {
            SpedEfdStore.obs.tab_entrada_saida = tab;
        }
    }

    async hanldeChangeTabSaida(tab: string) {
        SpedEfdStore.obs.cfops_current = 1

        if (tab == "cfops") {
            await SpedEfdStore.loadCfops("saida", 1, SpedEfdStore.obs.config_id)
            SpedEfdStore.obs.select_config_saidas_tab = tab;
        }
        else if (tab == "import") {
            this.obs.open_select_import_saida = true
        }
        else {
            SpedEfdStore.obs.select_config_saidas_tab = tab;
        }
    }

    async hanldeChangeTabEntrada(tab: string) {
        SpedEfdStore.obs.cfops_current = 1

        if (tab == "cfops") {
            await SpedEfdStore.loadCfops("entrada", 1, SpedEfdStore.obs.config_id)
            SpedEfdStore.obs.select_config_entradas_tab = tab;
        }
        else if (tab == "import") {
            this.obs.open_select_import_entrada = true
        }
        else if (tab == "csts") {
            SpedEfdStore.loadCsts(SpedEfdStore.obs.config_id);
            SpedEfdStore.obs.select_config_entradas_tab = tab;
        }
        else {
            SpedEfdStore.obs.select_config_entradas_tab = tab;
        }
    }

    async handleImportNotas(e: boolean) {
        SpedEfdStore.obs.sped.import_notas = e

        let params = {
            import_notas: e,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }

    async handleGerarInformacoes(e: any) {
        if (SpedEfdStore.obs.sped.gerar_informacoes) {
            SpedEfdStore.obs.sped.informacoes_conforme = "nota"

        } else {
            SpedEfdStore.obs.sped.informacoes_conforme = ""
        }

        let params = {
            gerar_informacoes: SpedEfdStore.obs.sped.gerar_informacoes,
            informacoes_conforme: SpedEfdStore.obs.sped.informacoes_conforme,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }

    async handleICMSAntecipado(e: any) {

        if(!SpedEfdStore.obs.sped.icms_config) {
            SpedEfdStore.obs.sped.cst_icms_config = false
            SpedEfdStore.obs.sped.cfop_icms_config = false
        }

        let params = {
            icms_config: SpedEfdStore.obs.sped.icms_config,
            cst_icms_config: SpedEfdStore.obs.sped.cst_icms_config,
            cfop_icms_config: SpedEfdStore.obs.sped.cfop_icms_config,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }

    async handleCSTConfig(e: any) {

        let params = {
            cst_icms_config: SpedEfdStore.obs.sped.cst_icms_config,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }

    async handleCFOPICMSConfig(e: any) {

        let params = {
            cfop_icms_config: SpedEfdStore.obs.sped.cfop_icms_config,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }


    async handleDeduzirIcms(e: boolean) {
        SpedEfdStore.obs.sped.deduzir_icms = e

        let params = {
            deduzir_icms: e,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }

    onClose() {
        this.obs.open_select_import_entrada = false
        this.obs.open_select_import_saida = false
        SpedEfdStore.obs.selectedEmpresaImport = newEmpresa()
        SpedEfdStore.obs.modelo = "selecione"
    }

    render() {

        return (
            <>
                <Tabs
                    id="tabs"
                    className={"tabsCalculos"}
                    selectedTabId={SpedEfdStore.obs.tab_entrada_saida}
                    onChange={(tabId) => this.hanldeChangeTabConfig(String(tabId))}
                >
                    <Tab
                        id="geral"
                        title="Geral"
                        panel={
                            <MDBCol>
                                <h4 className="sub-title-sped">Modelo documento</h4>
                                <MDBCol md="12">
                                        <FormGroup label="Espécie NF-e">
                                            <MDBRow>
                                                <MDBCol md="1">
                                                    <InputGroup
                                                        value="55"
                                                        disabled
                                                        type="text" />
                                                </MDBCol>
                                                <MDBCol md="3">
                                                    <InputGroup
                                                        disabled
                                                        value={"Nota Fiscal Eletrônica (NF-e)"}
                                                        type="text" />
                                                </MDBCol>
                                            </MDBRow>
                                        </FormGroup>
                                </MDBCol>
                            </MDBCol>
                        }
                    />

                    <Tab
                        id="saida"
                        title="Saídas"
                        panel={
                            <>
                                <Tabs
                                    id="tabsS"
                                    className={"tabsCalculos"}
                                    selectedTabId={SpedEfdStore.obs.select_config_saidas_tab}
                                    onChange={(tabId) => this.hanldeChangeTabSaida(String(tabId))}
                                >
                                    <Tab
                                        id="opcoes"
                                        title="Opções"
                                        panel={
                                            <>
                                                <MDBCol md="12" style={{ marginTop: "20px" }}>
                                                    <MDBCol>
                                                        <MDBRow>
                                                            <input
                                                                type="checkbox"
                                                                className="chaves"
                                                                id="gerar_info"
                                                                name="gerar_info"
                                                                onChange={(e) => this.handleGerarInformacoes(SpedEfdStore.obs.sped.gerar_informacoes = e.target.checked)}
                                                                checked={SpedEfdStore.obs.sped.gerar_informacoes}
                                                            />
                                                            <label htmlFor="gerar_info" className="label-feriados">Gerar informações complementares no SPED conforme informado nas notas fiscais.</label>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </MDBCol>
                                            </>
                                        }
                                    />

                                    <Tab
                                        id="cfops"
                                        title="CFOPs"
                                        panel={
                                            <CfopSaida />
                                        }
                                    />
                                    <Tab
                                        id="import"
                                        title="Importar"
                                        panel={
                                            <ImportCfops isOpen={this.obs.open_select_import_saida} onClose={this.onClose.bind(this)} />
                                        }
                                    />

                                </Tabs>
                            </>
                        }
                    />

                    <Tab
                        id="entrada"
                        title="Entradas"
                        panel={
                            <>
                                <Tabs
                                    id="tabsS"
                                    className={"tabsCalculos"}
                                    selectedTabId={SpedEfdStore.obs.select_config_entradas_tab}
                                    onChange={(tabId) => this.hanldeChangeTabEntrada(String(tabId))}
                                >
                                    <Tab
                                        id="opcoes"
                                        title="Opções"
                                        panel={
                                            <>
                                                <MDBCol md="12" style={{ marginTop: "20px" }}>
                                                    <MDBCol>
                                                        <MDBRow>
                                                            <input
                                                                type="checkbox"
                                                                className="chaves"
                                                                id="gerar_info"
                                                                name="gerar_info"
                                                                onChange={(e) => this.handleGerarInformacoes(SpedEfdStore.obs.sped.gerar_informacoes = e.target.checked)}
                                                                checked={SpedEfdStore.obs.sped.gerar_informacoes}
                                                            />
                                                            <label htmlFor="gerar_info" className="label-feriados">Gerar informações complementares no SPED conforme informado nas notas fiscais.</label>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </MDBCol>
                                                <MDBCol md="12" style={{ marginTop: "20px" }}>
                                                    <MDBCol>
                                                        <MDBRow>
                                                            <input
                                                                type="checkbox"
                                                                className="chaves"
                                                                id="icms_config"
                                                                name="icms_config"
                                                                onChange={(e) => this.handleICMSAntecipado(SpedEfdStore.obs.sped.icms_config = e.target.checked)}
                                                                checked={SpedEfdStore.obs.sped.icms_config}
                                                            />
                                                            <label htmlFor="icms_config" className="label-feriados">Zerar ICMS no item quando houver ICMS antecipado ou Substituição Tributária.</label>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </MDBCol>
                                                <MDBCol md="12" style={{ marginTop: "20px" }}>
                                                    <MDBCol>
                                                        <MDBRow>
                                                            <input
                                                                type="checkbox"
                                                                className="chaves"
                                                                id="cst_icms_config"
                                                                name="cst_icms_config"
                                                                disabled={!SpedEfdStore.obs.sped.icms_config}
                                                                
                                                                onChange={(e) => this.handleCSTConfig(SpedEfdStore.obs.sped.cst_icms_config = e.target.checked)}
                                                                checked={SpedEfdStore.obs.sped.cst_icms_config}
                                                            />
                                                            <label htmlFor="icms_config" className="label-feriados">Utilizar CST ICMS 010 quando houver ICMS antecipado ou Substituição Tributária.</label>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </MDBCol>
                                                <MDBCol md="12" style={{ marginTop: "20px" }}>
                                                    <MDBCol>
                                                        <MDBRow>
                                                            <input
                                                                type="checkbox"
                                                                className="chaves"
                                                                id="cfop_icms_config"
                                                                name="cfop_icms_config"
                                                                disabled={!SpedEfdStore.obs.sped.icms_config}

                                                                onChange={(e) => this.handleCFOPICMSConfig(SpedEfdStore.obs.sped.cfop_icms_config = e.target.checked)}
                                                                checked={SpedEfdStore.obs.sped.cfop_icms_config}
                                                            />
                                                            <label htmlFor="icms_config" className="label-feriados">Utilizar CFOP 1403 ou 2403 quando houver ICMS antecipado ou Substituição Tributária.</label>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </MDBCol>
                                            </>
                                        }
                                    />

                                    <Tab
                                        id="cfops"
                                        title="CFOPs"
                                        panel={
                                            <CfopEntrada />
                                        }
                                    />
                                    <Tab
                                        id="csts"
                                        title="CSTs"
                                        panel={
                                            <Tabs
                                                id="tabsS"
                                                className={"tabsCalculos"}
                                            >
                                                <Tab
                                                    id="cst-pis"
                                                    title="CST PIS"
                                                    panel={
                                                        < CstsPIS />
                                                    }
                                                />
                                                <Tab
                                                    id="cst-cofins"
                                                    title="CST COFINS"
                                                    panel={
                                                        <CstsCofins />
                                                    }
                                                />
                                                <Tab
                                                    id="cst-ipi"
                                                    title="CST IPI"
                                                    panel={
                                                        <CstsIPI />
                                                    }
                                                />
                                            </Tabs>
                                        }
                                    />
                                    <Tab
                                        id="import"
                                        title="Importar"
                                        panel={
                                            <ImportCfops isOpen={this.obs.open_select_import_entrada} onClose={this.onClose.bind(this)} />
                                        }
                                    />
                                </Tabs>
                            </>
                        }
                    />
                </Tabs>
            </>
        )
    }
}